import types from "./types";
import { types as oetTypes } from "../../oet/redux";

const initialState = {
    list: [],
    selectedCpo: null,
    error: null,
    loading: false,
    loaded: false,
    pagination: {
        actualPage: 1,
        previous: null,
        next: null,
        pages: 0,
        count: 0
    },
    filters: {},
    report_message: "",
    report_last_response: "",
    cancellingSelectedCPO: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CPO_ITEMS:
        case types.GET_CPO_ITEM:
        case types.GET_CPO_HISTORY:
        case types.GET_CPO_ITEM_COMMENTS:
        case types.NEW_CPO_ITEM_COMMENT:
        case types.CANCEL_CPO_ITEM:
        case types.REPORT_START:
        case types.NON_OET_RELATED_CPO:
        case types.UPDATE_CPO:
        case types.GET_All: {
            return {
                ...state,
                loading: true,
                loaded: false
            };
        }

        case types.GET_All_SUCCESS: {
            const list = action.payload.list.reduce((entities, row, idx) => {
                return {
                    ...entities,
                    [`${row.cpo.number}${row.cpo.id? `_${row.cpo.id}` : ""}${row.oet.id ? `_${row.oet.id}${row.run.id ? `_${row.run.id}` : ""}` : ""}`]: {
                        ...row
                    }
                };
            }, {});
            return {
                ...state,
                list,
                fields: action.payload.fields,
                loading: false,
                loaded: true
            };
        }

        case types.GET_All_FAIL: {
            return {
                ...state,
                list: [],
                loading: false,
                loaded: false,
                error: action.payload
            };
        }

        case types.CHANGE_PAGE: {
            return {
                ...state,
                loading: true,
                pagination: {
                    ...state.pagination,
                    actualPage: action.payload.page
                }
            };
        }

        case types.UPDATE_PAGINATION: {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    actualPage: action.payload.actual,
                    pages: action.payload.pages,
                    next: action.payload.next,
                    previous: action.payload.previous,
                    count: action.payload.count
                }
            };
        }

        case types.FILTER_LIST: {
            return {
                ...state,
                filters: action.payload
            };
        }

        case types.GET_CPO_ITEMS_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true,
                selectedCpo: {
                    ...action.payload,
                    cpo_items: action.payload.cpo_items.map((entities, item) => {
                        return {
                            ...entities,
                            [item.item]: item
                        };
                    }, {})
                }
            };
        }

        case types.CANCEL_CPO_ITEM_SUCCESS:
        case types.GET_CPO_ITEM_SUCCESS: {
            const { item, cpoID, itemID } = action.payload;
            const oldCpo = state.selectedCpo || { id: cpoID };
            return {
                ...state,
                loading: false,
                loaded: true,
                selectedCpo: {
                    ...oldCpo,
                    cpo_items: {
                        ...oldCpo.cpo_items,
                        [itemID]: {
                            ...item
                        }
                    }
                }
            };
        }

        case types.GET_CPO_HISTORY_SUCCESS: {
            const historys = action.payload;
            return {
                ...state,
                selectedCpo: {
                    ...state.selectedCpo,
                    historys
                }
            };
        }

        case types.GET_CPO_ITEM_COMMENTS_SUCCESS: {
            const { comments, cpoID, itemID } = action.payload;
            const oldCpo = state.selectedCpo || { id: cpoID };

            return {
                ...state,
                selectedCpo: {
                    ...oldCpo,
                    cpo_items: {
                        ...oldCpo.cpo_items,
                        [itemID]: {
                            ...oldCpo.cpo_items[itemID],
                            comments
                        }
                    }
                },
                loading: false,
                loaded: true
            };
        }

        case types.NEW_CPO_ITEM_COMMENT_SUCCESS: {
            const comment = action.payload;
            const oldCpo = state.selectedCpo || { id: comment.cpo_number };
            return {
                ...state,
                selectedCpo: {
                    ...oldCpo,
                    cpo_items: {
                        ...oldCpo.cpo_items,
                        [comment.item_id]: {
                            ...oldCpo.cpo_items[comment.item_id],
                            comments: [...oldCpo.cpo_items[comment.item_id].comments, comment]
                        }
                    }
                },
                loading: false,
                loaded: true
            };
        }

        case types.GET_CPO_ITEM_FAIL:
        case types.GET_CPO_HISTORY_FAIL:
        case types.GET_CPO_ITEM_COMMENTS_FAIL:
        case types.NEW_CPO_ITEM_COMMENT_FAIL:
        case types.CANCEL_CPO_ITEM_FAIL:
        case types.NON_OET_RELATED_CPO_FAIL:
        case types.GET_CPO_ITEMS_FAIL: {
            return {
                ...state,
                loading: false,
                loaded: false,
                selectedCpo: {
                    ...state.selectedCpo,
                    error: action.payload
                }
            };
        }

        case types.CANCEL_CPO: {
            return {
                ...state,
                cancellingSelectedCPO: true,
                loading: true,
                loaded: false
            };
        }

        case types.CANCEL_CPO_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true,
                cancellingSelectedCPO: false,
                selectedCpo: {
                    ...state.selectedCpo,
                    cpo_register: action.payload
                }
            };
        }

        case types.CANCEL_CPO_FAIL: {
            return {
                ...state,
                cancellingSelectedCPO: false,
                loading: false,
                loaded: false
            };
        }

        case types.REPORT_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true,
                report_message: action.payload,
                report_last_response: "info"
            };
        }
        case types.REPORT_ERROR: {
            return {
                ...state,
                loading: false,
                loaded: true,
                report_message: action.payload,
                report_last_response: "danger"
            };
        }

        case types.REPORT_CLEAN: {
            return {
                ...state,
                loading: false,
                loaded: false,
                report_message: "",
                report_last_response: ""
            };
        }

        case types.NON_OET_RELATED_CPO_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true,
                selectedCpo: {
                    ...state.selectedCpo,
                    ...action.payload
                }
            };
        }

        // ok
        case oetTypes.CREATE_OET_IN_SUCCESS: {
            return {
                ...state,
                selectedCpo: {
                    ...state.selectedCpo,
                    oet: action.payload
                }
            };
        }

        case types.UPDATE_CPO_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true,
                selectedCpo: {
                    ...state.selectedCpo,
                    ...action.payload
                }
            };
        }

        case types.UPDATE_CPO_FAIL: {
            const error = action.payload;
            console.log({ error });
            return {
                ...state,
                loading: false,
                loaded: false
            };
        }

        case types.RE_OPEN_CPO: {
            return {
                ...state,
                loading: true,
                loaded: false
            };
        }
        case types.RE_OPEN_CPO_END: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }

        default: {
            return state;
        }
    }
};
